import { useSelector } from 'react-redux';
import { getIsLoggedInSelector } from '@americanexpress/travel-selectors';
import { v4 as generateUUID } from 'uuid';
import { ignoreHeadersByKey } from 'fetchye';
import { useErrorOnUnexpectedStatusFetchye } from '@americanexpress/fetchye-amex';
import { getContextApiUrlSelector } from '../selectors/getContextApiSelectors';
import { TRAVELER_V1_CLIENT_ID_ONLINE } from '../constants/travelerDataConstants';
import { fetchyeReporter } from '../utils/fetchyeReporterUtil';
import { useIsCenturionContext } from '../context/isCenturionContext';
import { useFeatureFlagWithProperties } from '../thunks/useFeatureFlagWithProperties';
import { ABANDON_CART_FF } from '../constants/oneXpConstants';

const generateHeaders = () => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  clientId: TRAVELER_V1_CLIENT_ID_ONLINE,
  correlation_id: generateUUID(),
});

const getPayload = () => ({
  context: [
    {
      code: 'REQUESTED_CONTEXT',
      value: 'CARTABANDON',
    },
  ],
});

const useContextAPI = () => {
  const hasDisplayAbandonHotel = useFeatureFlagWithProperties(ABANDON_CART_FF);
  const isCenturion = useIsCenturionContext();
  const isLoggedIn = useSelector(getIsLoggedInSelector);
  const contextApiUrl = useSelector(getContextApiUrlSelector);

  const options = {
    method: 'POST',
    defer: !isLoggedIn || !hasDisplayAbandonHotel || isCenturion,
    headers: generateHeaders,
    body: JSON.stringify(getPayload()),
    credentials: 'include',
    mapOptionsToKey: ignoreHeadersByKey(['correlation_id']),
  };
  const fetcherOpts = {
    expectedStatuses: [200],
    reporting: fetchyeReporter({ component: 'useContextAPI' }),
  };
  const {
    isLoading: contextLoading,
    data: contextResponse,
    error: contextError,
    run,
  } = useErrorOnUnexpectedStatusFetchye(contextApiUrl, options, fetcherOpts);

  return {
    isLoading: contextLoading,
    data: contextResponse?.body,
    error: contextError,
    run,
  };
};

export const useAbandonCartData = () => {
  const {
    isLoading, data, error, run,
  } = useContextAPI();

  return {
    isLoading,
    data: data?.cartAbandon || {},
    error,
    run,
  };
};
